
import { ReactNode } from "react"
import { LucideIcon } from "lucide-react"
import { cn } from "@/lib/utils"

interface SleepCellBaseProps {
  icon: LucideIcon
  iconColor: string
  children: ReactNode
  className?: string
}

export function SleepCellBase({ icon: Icon, iconColor, children, className }: SleepCellBaseProps) {
  return (
    <div className={cn("flex items-center gap-1", className)}>
      <Icon className={cn("w-2.5 h-2.5 xs:w-3 xs:h-3 sm:w-3.5 sm:h-3.5 flex-shrink-0", iconColor)} />
      <span className="text-2xs xs:text-xs sm:text-sm truncate mobile-truncate w-full max-w-[60px] xs:max-w-[80px] sm:max-w-[100px] md:max-w-full">
        {children}
      </span>
    </div>
  )
}
